import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const ShiftRoutes: RouteObject = {
	path: "/shift/*",
	lazy: async () => {
		const { ShiftHome } = await import("@/components/Shift/ShiftHome");
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={({ error, componentStack, resetError }) => (
						<PageError
							error={error}
							componentStack={componentStack}
							reset={resetError}
						/>
					)}
				>
					<ShiftHome />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		{
			index: true,
			lazy: async () => {
				const { ShiftHome } = await import("@/components/Shift/ShiftHome");
				return {
					Component: ShiftHome,
				};
			},
		},
		{
			path: "shift",
			lazy: async () => {
				const { ShiftLog } = await import("@/components/Shift/ShiftLog");
				return {
					Component: ShiftLog,
				};
			},
		},
	],
};
